export const CONTACT_FLOW_INITIATED = '[CONTACTME] CONTACT FLOW INITIATED';
export const CONTACT_FLOW_ABANDONED = '[CONTACTME] CONTACT FLOW ABANDONED';
export const MESSAGE_SEND_INITIATED = '[CONTACTME] MESSAGE SEND INITIATED';
export const MESSAGE_SEND_COMPLETED = '[CONTACTME] MESSAGE SEND COMPLETED';
export const MESSAGE_SEND_FAILED = '[CONTACTME] MESSAGE SEND FAILED';
export const SET_LEAD_NAME = '[CONTACTME] SET LEAD NAME';
export const SET_LEAD_EMAIL_ADDR = '[CONTACTME] SET LEAD EMAIL ADDRESS';
export const SET_LEAD_COMPANY = '[CONTACTME] SET LEAD COMPANY';
export const SET_LEAD_MESSAGE = '[CONTACTME] SET LEAD MESSAGE';
export const RESET_FIELDS = '[CONTACTME] RESET FIELDS';

export default {
  CONTACT_FLOW_INITIATED,
  CONTACT_FLOW_ABANDONED,
  MESSAGE_SEND_INITIATED,
  MESSAGE_SEND_COMPLETED,
  MESSAGE_SEND_FAILED,
  SET_LEAD_NAME,
  SET_LEAD_EMAIL_ADDR,
  SET_LEAD_COMPANY,
  SET_LEAD_MESSAGE,
  RESET_FIELDS,
};
